import { Component, OnInit, Input, OnChanges, Output, EventEmitter, ElementRef, Renderer } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { MatExpansionPanel } from '@angular/material';

import { Product } from '../../../../_models/product';
import { Template } from '../../../../_models/template';
import { CardService } from '../../card.service';
import { CardSvg } from '../../../../_models/card-svg';

@Component({
  selector: 'app-add-second-product',
  templateUrl: './add-second-product.component.html',
  styleUrls: ['./add-second-product.component.css']
})
export class AddSecondProductComponent implements OnInit, OnChanges {
  @Output() product = new EventEmitter<Product>();
  @Output() svg = new EventEmitter<string>();
  @Input() template: Template;
  cardSvg:CardSvg;
  template_has_v1_price_text_value = false;
  template_has_v2_price_text_value = false;
  expandPanel = false;
  extraProduct: Product = null;
  showForm = false;
  secondProductForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private cardService: CardService,
              private renderer: Renderer) { }

  ngOnInit() {
    // Check if our template has v1 and v2 price text values
    this.cardSvg = new CardSvg(this.template.svg);
    this.template_has_v1_price_text_value = this.cardSvg.hasV1PriceText;
    this.template_has_v2_price_text_value = this.cardSvg.hasV2PriceText;
  }

  ngOnChanges() {
    this.extractDataFromSVG();
  }

  extractDataFromSVG() {
    this.cardSvg = new CardSvg(this.template.svg);
    // We always set the form, if template doesn't have the values we simply don't show it
    let v1 = this.cardSvg.getValueIfItExists(CardSvg.v1_price_text_selector);
    let v2 = this.cardSvg.getValueIfItExists(CardSvg.v2_price_text_selector);
    if (v1 === undefined) { v1 = ''}
    if (v2 === undefined) { v2 = ''}
    this.secondProductForm = this.formBuilder.group({
      'v1_price_text': [v1],
      'v2_price_text': [v2]
    });

    // If we have a provided product, load it!
    if (this.template.second_product_id) {
      this.cardService.getProduct(this.template.second_product_id).subscribe(product => {
        this.setProduct(product, false);


      });
    }
    // For every formchange, send our new values back to our parent component
    this.secondProductForm.valueChanges.subscribe(data => {
      this.cardSvg.setValue(CardSvg.v1_price_text_selector, data.v1_price_text);
      this.cardSvg.setValue(CardSvg.v2_price_text_selector, data.v2_price_text);
      this.svg.emit(this.cardSvg.svg_html);
    })
  }

  setProduct(product: Product, expandPanel = true) {
    this.extraProduct = product;
    this.product.emit(product);
    this.expandPanel = expandPanel;
    this.showForm = true;
  }

  resetProduct(): void {
    this.showForm = false;
    this.extraProduct = null;
    this.product.emit(undefined);
  }

}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/modify-card/add-second-product/add-second-product.component.ts